export default __webpack_public_path__ + "static/media/add.efc2edb8.svg";